import React, {useMemo} from 'react';

import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {MenuWidth, OptionData} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface DataTableColumnPickerProps {
  allColumns: Array<{id: number; name: string}>;
  selectedColumnId: number | null;
  onSelectedColumnChange: (selectedColumn: {id: number; name: string}) => void;
}

export default function DataTableColumnPicker(props: DataTableColumnPickerProps): JSX.Element {
  const optionDatas = useMemo(
    () =>
      props.allColumns.map<OptionData>((column) => ({
        value: column.id,
        name: column.name,
      })),
    [props.allColumns]
  );
  const columnsById = useMemo(
    () =>
      props.allColumns.reduce<
        Record<
          number,
          {
            id: number;
            name: string;
          }
        >
      >((acc, column) => {
        acc[column.id] = column;
        return acc;
      }, {}),
    [props.allColumns]
  );

  return (
    <FormGroup>
      <Label className="u-text-uppercase">{MODEL_NAMES.Result_Table} Field</Label>
      <SelectDropdown
        displayName={
          props.selectedColumnId == null ? 'Select a column' : columnsById[props.selectedColumnId].name
        }
        menu={
          <SearchableMenu
            onSelect={(selectedValue) => {
              props.onSelectedColumnChange(columnsById[selectedValue]);
            }}
            optionDatas={optionDatas}
            selectedValue={props.selectedColumnId}
            width={MenuWidth.FULL}
          />
        }
      />
    </FormGroup>
  );
}
